import GetSchedulerByAppointmentsRequestModelBase from '../_generated/modelBases/get-scheduler-by-appointments-request-model-base';

export default class GetSchedulerByAppointmentsRequestModel extends GetSchedulerByAppointmentsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
